import React from 'react';
import { Typography } from '@one-thd/sui-atomic-components';
import { EmptyThumbnails } from '../ShareableListCardPlaceholder';
import { listImagesPropTypes } from '../utils/propTypes';

const ListImages = ({ images, itemCount, numberOfThumbnails }) => {
  if (itemCount <= 0 || !images || images.length === 0) {
    return <EmptyThumbnails numberOfThumbnails={numberOfThumbnails + 1} />;
  }

  return (
    <div className="sui-flex sui-flex-nowrap sui-gap-2 sui-overflow-x-hidden">
      {images.slice(0, numberOfThumbnails).map((image, index) => (
        <img
          key={`list-image-${index}`}
          src={image.url}
          alt={`List item ${index + 1}`}
          width="auto"
          height="auto"
          className="sui-w-14 @sm:sui-w-20 @xl:sui-w-24 sui-aspect-square sui-object-cover"
          data-testid={`list-image-${index}`}
        />
      ))}
      {itemCount > numberOfThumbnails && (
        <div
          className="sui-w-14 @sm:sui-w-20 @xl:sui-w-24 sui-aspect-square sui-grid
          sui-place-items-center sui-bg-strong"
          data-testid="list-image-more"
        >
          <Typography>+{itemCount - numberOfThumbnails}</Typography>
        </div>
      )}
    </div>
  );
};

ListImages.propTypes = listImagesPropTypes;

export default ListImages;